<template>
  <div
    class="flex flex-row gap-8 rounded-xl border-2 p-4 dark:border-dark-4 dark:bg-dark-3"
    :class="[
      {
        'border-primary-2 dark:border-primary-2':
          radiator.id === selectedRadiator,
      },
    ]"
    @click="selectRadiator(radiator)"
  >
    <div class="flex flex-col">
      <div
        class="has-text-weight-bold"
        :class="[{ 'text-primary-2': radiator.id === selectedRadiator }]"
      >
        {{ radiatorLabel }}
      </div>
      <div>
        {{ radiatorIdentification.model }}
      </div>
      <div>{{ radiator.getDimensions() }}</div>
    </div>
    <div v-if="getHKVsOfRadiator.length > 0" class="flex grow flex-col">
      <div class="has-text-weight-bold">HKV</div>
      <div class="flex flex-col gap-4">
        <div v-for="device in getHKVsOfRadiator" :key="device.id">
          <div class="flex gap-2">
            <div class="flex-col">
              <div>S/Nr</div>
              <div>EAN</div>
            </div>
            <div class="flex-col">
              <div>{{ device.serialNumber }}</div>
              <div>{{ device.customizedNumber }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="getSRTsOfRadiator.length > 0" class="flex grow flex-col">
      <div class="has-text-weight-bold">SRT</div>
      <div class="flex flex-col gap-4">
        <div v-for="device in getSRTsOfRadiator" :key="device.id">
          <div class="flex gap-2">
            <div class="flex-col">
              <div>S/Nr</div>
              <div>EAN</div>
            </div>
            <div class="flex-col">
              <div>{{ device.serialNumber }}</div>
              <div>{{ device.customizedNumber }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col justify-center">
      <TertiaryButton
        v-if="isUnidentifiedPlaceholderRadiator"
        label="Heizkörper identifizieren"
        class="mx-0 my-0"
        data-testid="button-identify-radiator"
        @click="identifyRadiator"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import TertiaryButton from '@/components/UI/Button/TertiaryButton.vue';
import { deviceTypes } from '@/enums/device';
import { useDeviceStore } from '@/store/entities/deviceStore';
import { useFormStore } from '@/store/form/formStore';
import { computed, ComputedRef } from 'vue';
import RadiatorRating from '@/models/radiators/RadiatorRating';

const props = defineProps<{
  radiator: any;
  selectRadiator: (radiator: any) => void;
  selectedRadiator: any;
}>();

const radiatorLabel = computed(() => {
  return props.radiator.getRadiatorLabel();
});

const isIdentified = computed(() => {
  return !!props.radiator.identificationResult;
});

const radiatorIdentification: ComputedRef<RadiatorRating> = computed(() => {
  if (!isIdentified.value) {
    return '';
  }
  return props.radiator.identificationResult;
});

const getHKVsOfRadiator = computed(() => {
  return useDeviceStore().getDevicesOnRadiator(
    props.radiator.id,
    deviceTypes.HeatCostAllocator
  );
});

const getSRTsOfRadiator = computed(() => {
  return useDeviceStore().getDevicesOnRadiator(
    props.radiator.id,
    deviceTypes.SmartRadiatorThermostat
  );
});
const isUnidentifiedPlaceholderRadiator = computed(() => {
  return props.radiator.isPlaceholderRadiator();
});

const identifyRadiator = () => {
  useFormStore().editEntity(
    props.radiator,
    props.radiator.parentRoomId,
    {},
    true
  );
};
</script>
